import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { api } from "@/lib/api";
import { Sparkles, X } from "lucide-react";

export default function WhatsNewBanner() {
  const qc = useQueryClient();
  const { data } = useQuery({ queryKey: ["releases"], queryFn: async () => (await api.get("/releases")).data });
  const unseenId = data?.unseen?.[0];
  const release = (data?.releases || []).find((r) => r.id === unseenId);
  const seenMut = useMutation({
    mutationFn: async (rid) => api.post(`/releases/${rid}/seen`),
    onSuccess: () => qc.invalidateQueries({ queryKey: ["releases"] }),
  });
  if (!release) return null;
  return (
    <div className="bg-slate-900 text-white px-4 lg:px-10 py-2.5 flex items-center gap-3 flex-wrap" data-testid="whats-new-banner">
      <Sparkles size={15} className="text-cyan-400 shrink-0" />
      <p className="text-xs flex-1 min-w-[200px]">
        <span className="font-bold text-cyan-300 uppercase tracking-wider text-[10px] mr-2">What's new</span>
        {release.title} — see everything that changed and how to use it.
      </p>
      <a href={release.url} target="_blank" rel="noreferrer" onClick={() => seenMut.mutate(release.id)}
        className="text-xs font-semibold bg-cyan-600 hover:bg-cyan-700 px-3 py-1.5 rounded-sm transition-colors"
        data-testid="whats-new-view-btn">
        Read the release notes
      </a>
      <button onClick={() => seenMut.mutate(release.id)} className="text-slate-400 hover:text-white" data-testid="whats-new-dismiss-btn">
        <X size={15} />
      </button>
    </div>
  );
}
